/**
 * Constants related to permissions
 */
export enum PERMISSIONS {
  ACCESS = 'sell_screen.view',

  SALE_DISCOUNT = 'sale.discount.manage',
  SALE_LAYBY = 'sale.layby.process',
  SALE_NOTES = 'sale.note.manage',
  SALE_ON_ACCOUNT = 'sale.on_account.process',
  SALE_PARKED = 'sale.parked.process',
  SALE_REMOVE_TAX = 'sale.tax.remove',
  SALE_RETURN = 'sale.return.process',
  SALE_PROCESS = 'sale.regular.process',

  PRODUCT_VIEW_COST = 'product.cost.view',

  CUSTOMER_ADD_EDIT = 'customer.add_edit',
  CUSTOMER_ON_ACCOUNT_LIMIT_ADD_EDIT = 'customer.on_account_limit.add_edit',

  REGISTER_OPEN_CLOSE = 'register.closures.perform',
  REGISTER_STATUS_RESET = 'register.status.reset',

  SELL_SCREEN_SETTINGS_UPDATE = 'sell_screen.settings.update',

  CASH_FLOAT = 'cash_movement.float.add',
  CASH_IN_OUT = 'cash_movement.cash_in_out.add',
  CASH_PETTY = 'cash_movement.petty_cash_in_out.add',

  STORE_CREDIT_ISSUE_MANUAL = 'store_credit.issue.manual',
  STORE_CREDIT_ISSUE_RETURN = 'store_credit.issue.return',
  STORE_CREDIT_MANAGE = 'store_credit.manage',

  QUICK_KEYS_MANAGE = 'quick_keys.manage',

  PAYMENT_TYPE_ADD_EDIT = 'payment_type.add_edit',

  HISTORY_VIEW = 'sale.history.view',
  PRODUCT_VIEW = 'product.view',
  PRODUCT_ADD_EDIT = 'product.add_edit',

  REPORTING_REGISTER_CLOSURE = 'reporting.register_closure',

  PRODUCT_PACKAGING_BREAKDOWN_AT_SALE = 'sale.product.breakdown',

  LSPAY_PMOF_ADD_EDIT_USE = 'sale.payment_method_on_file.add_edit_use',
}

export enum RULES {
  LINE_ITEM_DISCOUNT = 'sale.line_item_discount.manage',
  TOTAL_SALE_DISCOUNT = 'sale.total_sale_discount.manage',
}

export const MIN_DISCOUNT_PERCENT = 0
export const MAX_DISCOUNT_PERCENT = 100
